import { memo } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useTranslation } from "next-i18next";

const clientLogos = [
  "/clients/address.webp",
  "/clients/doubletree.webp",
  "/clients/hilton.webp",
  "/clients/jumeirah.webp",
  "/clients/story.webp",
  "/clients/acpn-logo.webp",
  "/clients/adkr-logo.webp",
  "/clients/bafco-logo.webp",
  "/clients/cert-logo.webp",
  "/clients/czn-burak-logo.webp",
  "/clients/euromercato-logo.webp",
  "/clients/lux-motors-logo.webp",
  "/clients/maudsley-logo.webp",
  "/clients/the-h-dubai-logo.webp",
  "/clients/tvr-logo.webp",
  "/clients/ultimate-motors-logo.webp",
  "/clients/wellness-surgery-logo.webp",
];

const clientLogosAlt = [
  "Address logo – Prism Digital client",
  "Double Tree logo – Prism Digital client",
  "Hilton logo – Prism Digital client",
  "Jumeirah logo – Prism Digital client",
  "Story Hospitality Hotel client logo and hospitality marketing success",
  "American Center Psychiatry and Neurology client logo and healthcare marketing partner",
  "Rnight Riders logo – Prism Digital client",
  "BAFCO logo – Prism Digital client",
  "CERT Higher Colleges of Technology logo – Prism Digital client",
  "CZN Burak logo – Prism Digital client",
  "Euromercato logo – Prism Digital client",
  "Lux Motors automotive marketing client logo featured by Prism Digital",
  "Maudsley Health client logo and healthcare digital marketing case study",
  "The H Hotel Dubai hospitality marketing client logo and success story",
  "Turkish Village Restaurant logo – Prism Digital client",
  "Ultimate Motors logo – Prism Digital client",
  "Wellness Center healthcare client logo and digital marketing campaign",
];

const Clients = memo(() => {
  const { t } = useTranslation("common");

  return (
    <div className="w-full box-border border-gray-500 border-solid border-b-[1px] flex flex-col lg:flex-row items-center justify-between px-[24px] md:px-[60px] lg:px-[80px] py-[40px] lg:py-[60px] mb-[40px] lg:mb-[60px] gap-6 md:gap-10 max-w-[1600px] mx-auto">
      <h2 className="m-0 self-center text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium whitespace-nowrap">
        {t("clients.title")}
      </h2>

      <div className="lg:w-[75%] w-full">
        <Swiper
          modules={[Autoplay]}
          loop
          slidesPerView="auto"
          spaceBetween={60}
          speed={6000}
          allowTouchMove={false}
          autoplay={{
            delay: 0, // ✅ continuous
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="w-full clients-marquee"
        >
          {clientLogos?.map((logo, ind) => (
            <SwiperSlide key={`${logo}-${ind}`} style={{ width: 200 }}>
              <div className="flex items-center justify-center">
                <Image
                  src={logo}
                  alt={clientLogosAlt[ind] || `Client ${ind + 1} Image`}
                  width={160}
                  height={80}
                  className="object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
});

export default Clients;
